module.exports = __webpack_public_path__ + "img/diamond-icon.461fce30.svg";